import React from 'react';
import { useTranslation } from 'react-i18next';
import css from '../../summary-view.module.css';
import SummaryGraph from '../../summary-graph';
import { InseminationEntry } from '../../../../../interfaces/livestock-reproduction';

interface ReproductionData {
  inseminationIntervals: InseminationEntry[];
  greaterInterval: number | null;
}

export default function InseminationIntervalsSummary({
  reproductionData,
  title
}: {
  reproductionData: ReproductionData;
  title: string;
}) {

  const { t } = useTranslation();
  let totalIntervals = 0;
  let intervalBetween = 0;
  let intervalBetweenValue = 0;
  let secondIntervalBetweenValue = 0;

  Object.values(reproductionData.inseminationIntervals).forEach(data => {
    totalIntervals += data.value;

    if (data.interval === '18-24') {
      intervalBetween = data.percent;
      intervalBetweenValue = data.value;
    } else if (data.interval === '36-47') {
      secondIntervalBetweenValue = data.value;
    }
  });

  return (
    <div className={css['summary-container']}>
      <div className={css['left-panel']}>
        <div className={css['grid-container']}>
          <SummaryGraph
            title={title}
            height={193}
            xKey="interval"
            yLeftValue={t('pages.livestock.summary.view.percent_from_inseminated_cows')}
            barObjects={[
              {
                dataKey: "value",
                dataTitle: t('pages.livestock.summary.view.this_year'),
                strokeColor: "#12589F",
                yAxis: "left",
              },
              {
                dataKey: "prevYear",
                dataTitle: t('pages.livestock.summary.view.prev_year'),
                strokeColor: "#bbbaba",
                yAxis: "left",
              },
            ]}
            yAxisGoal='left'
            data={reproductionData.inseminationIntervals}
            xTitle={t('pages.livestock.summary.view.insemination_interval_days')}
          />

          <table className={css['under-table']}>
            <tbody className={css['strong']}>
              <tr>
                <td>{t('pages.livestock.summary.view.analysed_cows')}</td>
                <td>{totalIntervals}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>{t('pages.livestock.summary.view.interval_greater_than_50')}</td>
                <td>{~~reproductionData.greaterInterval}%</td>
                <td>{t('pages.livestock.summary.view.goal_dry_period')}</td>
                <td>20%</td>
              </tr>
              <tr>
                <td>{t('pages.livestock.summary.view.interval_between_18_and_24')}</td>
                <td>{(intervalBetween).toFixed(2)}%</td>
                <td>{t('pages.livestock.summary.view.goal_dry_period')}</td>
                <td>&gt;40%</td>
              </tr>
              <tr>
                <td>{t('pages.livestock.summary.view.interval_comparison')}</td>
                <td>{(intervalBetweenValue > 0) ? (intervalBetweenValue / secondIntervalBetweenValue).toFixed(2) : 0}%</td>
                <td>{t('pages.livestock.summary.view.goal_dry_period')}</td>
                <td>&gt;3%</td>
              </tr>
            </tbody>
          </table>

          <p className={css['desc']}>{t('pages.livestock.summary.view.interval_desc')}</p>

        </div>
      </div>

      <div className={css['left-panel']}>
        <table className={css['table']} style={{ width: '90%' }}>
          <thead>
            <tr>
              <th>{t('pages.livestock.summary.view.insemination_interval_days')}</th>
              <th>{t('pages.livestock.summary.view.low_yield_cow')}</th>
              <th>{t('pages.livestock.summary.view.percent_from_inseminated_cows')}</th>
              <th>{t('pages.livestock.summary.view.sum_of_percent')}</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(reproductionData.inseminationIntervals).map(([index, data]) => (
              <tr key={index}>
                <td>{data.interval}</td>
                <td>{data.value}</td>
                <td>{data.percent}</td>
                <td>{data.sum}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
